import Icon, { IconProps } from '@mui/material/Icon';
import { Typography } from '@mui/material';
import { ReactElement } from 'react';
import { animated, useSpring } from '@react-spring/web';
import { usePhrase } from '@/hooks';
import { GENERAL_PHRASES } from '@/consts/phrases/generalPhrases';

import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

interface CompletionStatusProps {
    color: IconProps['color'];
    phraseId: number;
    icon: ReactElement;
}

const CompletionStatus = (props: CompletionStatusProps) => {
    const springs = useSpring({
        from: { opacity: 0 },
        to: { opacity: 1 },
    });
    const { t } = usePhrase();
    return (
        //@ts-ignore
        <animated.div
            style={{ ...springs, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
            <Typography color={props.color}>{t(props.phraseId)}</Typography>
            <Icon
                style={{
                    padding: '0 10px',
                    width: 35,
                    height: 35,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
                color={props.color}
            >
                {props.icon}
            </Icon>
        </animated.div>
    );
};

export const Succeeded = (props: { message?: number }) => (
    <CompletionStatus
        color={'success'}
        phraseId={props.message ?? GENERAL_PHRASES.SAVED}
        icon={<CheckCircleIcon />}
    />
);
export const Failed = (props: { message?: number }) => (
    <CompletionStatus
        color={'error'}
        phraseId={props.message ?? GENERAL_PHRASES.FAILED}
        icon={<ErrorIcon />}
    />
);
